const BACKEND_HOST = process.env.BACKEND_HOST
const BACKEND_PORT = process.env.BACKEND_PORT
const MOKA_SERVICE_HOST = process.env.MOKA_SERVICE_HOST
const HOST = `${BACKEND_HOST}:${BACKEND_PORT}`

export const MOKA_ACCOUNT_API = `${MOKA_SERVICE_HOST}/account`
export const MOKA_COUPON_BILLING_API = `${MOKA_SERVICE_HOST}/billing-coupon`
export const HOST_URL = `${HOST}`
export const API_URL = `${HOST}/api`
export const MOKA_SERVICE_URL = `${MOKA_SERVICE_HOST}`
export const LOGIN_URL = `${MOKA_ACCOUNT_API}/v1/login`
export const LOGOUT_URL = `${API_URL}/v2/logout`
export const REGISTER_URL = `${HOST}/validate_email?email=`
export const FORGOT_PASSWORD_URL = `${API_URL}/v1/users/forgot_password`
export const BUSINESS_TYPES = `${HOST}/business_types`
export const RESEND_VERIFICATION_EMAIL_URL = `${HOST}/resend_verification_email`
export const BUSINESS_CATEGORIES = `${HOST}/business_categories?business_type_id=$id`
export const BUSINESS_TYPES_URL = `${HOST}/business_types`
export const BUSINESS_CATEGORIES_URL = `${HOST}/business_categories`
export const REGISTER_BUSINESS_URL = `${HOST}/create_user`
export const UPDATE_SELECTED_OUTLET = `${API_URL}/v2/login/outlets`
export const GET_PROFILE = `${API_URL}/v1/profile`
export const GET_DASHBOARD = `${API_URL}/v1/dashboard`
export const GET_DASHBOARD_POST = `${MOKA_SERVICE_HOST}/reporting/v1/dashboard/lists`
export const GET_DASHBOARD_SUMMARY_POST = `${MOKA_SERVICE_HOST}/reporting/v1/dashboard/sales_summary`
export const REFERRAL_URL = `${HOST}/referral`
export const SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`

/**
 * Category endpoints
 */
export const LIST_CATEGORY_URL = `${API_URL}/v1/categories`
export const LIST_CATEGORY_WITH_UNCATEGORIZED_URL = `${API_URL}/v1/categories/with_uncategorized`

/**
 * Sales endpoints
 */
export const SALES_SUMMARY_URL = `${API_URL}/v1/reports/sales_summary`
export const SALES_SUMMARY_URL_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/sales_summary`
export const SALES_TYPE_URL = `${API_URL}/v1/reports/sales_type`
export const GROSS_PROFIT_URL = `${API_URL}/v1/reports/gross_profit`
export const GROSS_PROFIT_URL_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/gross_profit`
export const PAYMENT_METHODS_URL = `${API_URL}/v1/reports/payment_methods`
export const ITEM_SALES_URL = `${API_URL}/v2/reports/item_sales`
export const CATEGORY_SALES_URL = `${API_URL}/v1/reports/category_sales`
export const MODIFIER_SALES_URL = `${API_URL}/v1/reports/modifiers`
export const DISCOUNTS_URL = `${MOKA_SERVICE_URL}/report/v1/discounts`
export const TAXES_URL = `${API_URL}/v1/reports/taxes`
export const GRATUITY_URL = `${API_URL}/v1/reports/gratuities`
export const COLLECTEDBY_URL = `${API_URL}/v1/reports/staff_report`
export const SERVEDBY_URL = `${API_URL}/v1/reports/servers`

/****
 * Cash drawer - shifts endpoints
 */
export const CASH_DRAWER_SHIFT_SUMMARY = `${API_URL}/v1/cash_drawer/shifts/summary`
export const CASH_DRAWER_LIST_SHIFT = `${API_URL}/v1/cash_drawer/shifts`
export const CASH_DRAWER_EXPORT_SHIFT = `${API_URL}/v1/cash_drawer/shifts/export`

/**
 * @return {string}
 */
export function CASH_DRAWER_SHIFT_DETAILS (shiftId) { return (`${API_URL}/v1/cash_drawer/shifts/${shiftId}`) }
export const UPDATE_FILTERED_DATE = `${API_URL}/v1/update_filtered_date`
export const GET_FILTERED_DATE = `${API_URL}/v1/get_filtered_date`
export const GET_RESET_PASSWORD_URL = `${API_URL}/v1/users/reset_password`
export const RESET_PASSWORD_URL = `${API_URL}/v1/users/update_password`
export const LOAD_PREPARE_ENCRYPTION_URL = `${API_URL}/v1/users/prepare_encryption`

/************************************************
 * Transactions endpoint
 ************************************************/
export const REPORT_TRANSACTION = `${API_URL}/v1/reports/transactions`
/**
 * @return {string}
 */
export function REPORT_TRANSACTION_DETAIL (transactionId) { return `${API_URL}/v1/reports/${transactionId}/transaction_detail` }
/**
  * Invoices endpoints
  */
export const INVOICES_URL = `${API_URL}/v1/reports/invoices`
export function RECEIPT_INVOICES_URL (id) { return (`${API_URL}/v1/invoices/${id}.json`) }

export const RECORD_PAYMENT_URL = `${API_URL}/v1/invoices/payment_records`
export function RESEND_EMAIL_URL (invoiceId) { return (`${API_URL}/v1/invoices/${invoiceId}/resend_email`) }

/***
 * Email receipt endpoint
 */
export const EMAIL_RECEIPT = `${API_URL}/v1/email_receipt`

/************************************************
 * Refund endpoint
 ************************************************/
export const REFUNDS = `${API_URL}/v2/refunds`
export const OLD_REFUNDS = `${API_URL}/v1/refunds`

/************************************************************************************************
 * End Refund Endpoint
 ************************************************************************************************/

/************************************************************************************************
 * Outlets endpoint
 ************************************************************************************************/
export const OUTLETS_URL = `${API_URL}/v1/outlets`

/************************************************************************************************
 * End outlets endpoint
 ************************************************************************************************/
export function PRINT_RECEIPT_INVOICE_PDF (invoiceId) { return (`${API_URL}/v1/invoices/${invoiceId}` + '.pdf') }
export const SETTING_ACCOUNT = `${API_URL}/v1/users/settings`
export const EXPORT_INVOICES = `${API_URL}/v1/invoices/export`
export function SETTING_PUBLIC_PROFILE (businessId) { return (`${API_URL}/v1/businesses/${businessId}`) }
export const GET_NEW_IMAGE_URL = `${API_URL}/v1/s3/new`
export const GET_LOADING_IMAGE = `${HOST}/assets/item-image-loading.gif`
export const UPLOAD_IMAGE = `https://mokapos-development.s3.amazonaws.com/`
export const CHECKOUT_SETTING = `${API_URL}/v1/checkout_setting`

/************************************************************************************************
 * Export endpoint
 ************************************************************************************************/
export const EXPORT_TRANSACTION = `${API_URL}/v1/reports/export_transactions`
export const EXPORT_SUMMARY = `${API_URL}/v1/reports/export_sales_summary`
export const EXPORT_SUMMARY_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_sales_summary`
export const EXPORT_SALES_TYPE = `${API_URL}/v1/reports/export_sales_type`
export const EXPORT_GROSS_PROFIT = `${API_URL}/v1/reports/export_gross_profit`
export const EXPORT_GROSS_PROFIT_OPTIMIZE = `${MOKA_SERVICE_HOST}/reporting/v1/reports/export_gross_profit`
export const EXPORT_PAYMENT_METHOD = `${API_URL}/v1/reports/export_payment_methods`
export const EXPORT_ITEM_SALES = `${API_URL}/v1/reports/export_item_sales`
export const EXPORT_CATEGORY_SALES = `${API_URL}/v1/reports/export_category_sales`
export const EXPORT_MODIFIER_SALES = `${API_URL}/v1/reports/export_modifiers`
export const EXPORT_DISCOUNT = `${MOKA_SERVICE_URL}/report/v1/discounts/export`
export const EXPORT_TAXES = `${API_URL}/v1/reports/export_taxes`
export const EXPORT_GRATUITY = `${API_URL}/v1/reports/export_gratuities`
export const EXPORT_COLLECTEDBY = `${API_URL}/v1/reports/export_staff_report`
export const EXPORT_SERVEDBY = `${API_URL}/v1/reports/export_servers`
/************************************************************************************************
 * End Export endpoint
 ************************************************************************************************/

 /************************************************************************************************
  * Customers feedback endpoint
  ************************************************************************************************/
export const LIST_CUSTOMER_FEEDBACK_URL = `${API_URL}/v1/customer_feedbacks`
export function FEEDBACK_MESSAGES (feedbackId) { return (`${API_URL}/v1/customer_feedbacks/${feedbackId}/feedback_messages`) }
export const SUBMIT_REPLY_URL = `${API_URL}/v1/customer_feedbacks/submit_reply`
 /************************************************************************************************
  * End customers feedback endpoint
  ************************************************************************************************/



// WEBPACK FOOTER //
// ./app/api/constants.js